<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import store from '../stores/index'

export default defineComponent({
    name: 'AppLayoutApp',
    setup() {
        onMounted(() => store.init())
    },
})
</script>

<template>
    <!--
      Native: StatusBar overlays the WebView. The dashboard root
      (`.native-app-safe`) pads the top inset. Bottom safe-area stays
      in MobileNavBar / NativeLiquidGlassNav / page scroll padding (see main.css native-app notes).

      flex-1 min-h-0: fill the space below ImpersonationBanner (when shown)
      instead of covering the viewport. App.vue wraps this in a column.

      Do NOT put overflow-hidden here — it clips document scroll for public
      pages (landing, story, etc.) that rely on window scrolling. Native
      overflow containment lives on html.native-app #app in main.css;
      dashboard routes manage their own overflow.
    -->
    <main class="relative flex-1 min-h-0">
        <slot />
    </main>
</template>
